/**
 * 表示言語のレジストリ。言語を足すときは、辞書のフォルダ（config/i18n/<id>/）を足し、ここと loaders.ts に1件ずつ足す。
 * 選択肢の名前は、その言語を読める人が探せるよう、各言語自身の名前で書く（翻訳しない）。
 */
export const LANGUAGE_IDS = ['ja', 'en', 'zh-CN', 'ko', 'es', 'fr', 'de', 'pt-BR'] as const;
export type LanguageId = (typeof LANGUAGE_IDS)[number];

export interface LanguageDef {
  /** 選択肢に出す名前（その言語自身の表記） */
  label: string;
  /** `<html lang>` に入れる BCP 47 */
  htmlLang: string;
  /** ブラウザの言語（navigator.languages）のうち、この言語にあたるもの。小文字の接頭辞で前方一致 */
  matches: readonly string[];
  /** その言語の辞書に混ざってよい文字の種類。これ以外が混ざると辞書のテストが落ちる（未翻訳の取りこぼしを見つけるため） */
  scripts: readonly Script[];
}

export type Script = 'kana' | 'han' | 'hangul';

export const LANGUAGES: Record<LanguageId, LanguageDef> = {
  ja: { label: '日本語', htmlLang: 'ja', matches: ['ja'], scripts: ['kana', 'han'] },
  en: { label: 'English', htmlLang: 'en', matches: ['en'], scripts: [] },
  'zh-CN': { label: '简体中文', htmlLang: 'zh-CN', matches: ['zh'], scripts: ['han'] },
  ko: { label: '한국어', htmlLang: 'ko', matches: ['ko'], scripts: ['hangul'] },
  es: { label: 'Español', htmlLang: 'es', matches: ['es'], scripts: [] },
  fr: { label: 'Français', htmlLang: 'fr', matches: ['fr'], scripts: [] },
  de: { label: 'Deutsch', htmlLang: 'de', matches: ['de'], scripts: [] },
  'pt-BR': { label: 'Português (Brasil)', htmlLang: 'pt-BR', matches: ['pt'], scripts: [] },
};

/** 保存も端末の言語もないときの言語。辞書の正本 */
export const DEFAULT_LANGUAGE_ID: LanguageId = 'ja';
/** 言語の選択を保存するキー（端末の好みなので、設定（Settings）とは別に持つ） */
export const LANGUAGE_STORAGE_KEY = 'hitflow.language';
